import { graphql } from "../../shared/schema/gql";

/**
 * GraphQL query for Clock In & Out page with pagination and server-side filtering
 * Replaces the REST endpoint /clocked_visits
 */
export const GET_CLOCKED_VISIT_INSTANCES_QUERY = graphql(`
  query GetClockedVisitInstances(
    $limit: Int!
    $offset: Int!
    $order: [ClockedVisitInstance__Order]!
    $from: LocalDate
    $to: LocalDate
    $contracts: [ContractTypeId!]
    $serviceCodes: [ServiceCodeId!]
    $offices: [OfficeId!]
    $branches: [AgencyBranchId!]
    $coordinators: [AgencyMemberId!]
    $teams: [AgencyTeamId!]
    $certifications: [CaregiverCertification!]
    $clockMethods: [String!]
    $statuses: [EVVVisitStatus!]
    $search: String
    $evvErrorSearch: String
    $devHelpStatuses: [String!]
  ) {
    clockedVisitInstances(
      limit: $limit
      offset: $offset
      order: $order
      from: $from
      to: $to
      contracts: $contracts
      serviceCodes: $serviceCodes
      offices: $offices
      branches: $branches
      coordinators: $coordinators
      teams: $teams
      certifications: $certifications
      clockMethods: $clockMethods
      statuses: $statuses
      search: $search
      evvErrorSearch: $evvErrorSearch
      devHelpStatuses: $devHelpStatuses
    ) {
      totalCount
      nodes {
        id
        startTime
        endTime
        patientId
        caregiverId
        clockinTime
        clockoutTime
        clockinType
        clockoutType
        clockinLocation
        clockoutLocation
        duties
        officeId
        patientContractId
        billingInfo {
          filingLimitDaysLeft
        }
        patient {
          id
          firstName
          middleName
          lastName
          primaryAddress {
            geo
          }
        }
        caregiver {
          id
          firstName
          middleName
          lastName
        }
        contract {
          id
          contractType {
            id
            name
            evvAggregator
          }
        }
        serviceCode {
          id
          code
        }
        emednySubmission {
          transactionId
          submitted
          processedAt
          errorType
          errors
        }
        tellusSubmission {
          createdAt
          submitted
          errorCodes
        }
        sandataSubmission {
          submittedAt
          completed
          errors
        }
        hhaexchangeSubmission {
          submitted
          sentAt
          errorType
          errorMessage
          transactionId
        }
      }
    }
  }
`);
